<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Storico stati</span>
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ row.index + 1 }}
                        </template>
                        <template v-slot:cell(dataOraInizio)="{ item }">
                            <span>{{ formatDateTime(item.dataOraInizio) }}</span>
                        </template>
                        <template v-slot:cell(dataOraFine)="{ item }">
                            <span>{{ formatDateTime(item.dataOraFine) }}</span>
                        </template>
                    </b-table>
                </div>
            </div>

            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {
        // idAccettazione: { type: String },
    },

    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            filtro: { idAccettazione: null },
            pathResource: "/accettazionersasettinglivelli",
            showModalLoading: false,
            fields: [
                {
                    label: "",
                    key: "index",
                },
                {
                    label: "Descrizione livello",
                    key: "descrizioneLivello",
                    sortable: true,
                },
                {
                    label: "Descrizione setting",
                    key: "descrizioneSetting",
                    sortable: true,
                },
                {
                    label: "Data inizio",
                    key: "dataOraInizio",
                    sortable: true,
                },

                {
                    label: "Data fine",
                    key: "dataOraFine",
                    sortable: true,
                },
            ],
        };
    },
    mounted() {
        // let me = this;
        // me.loadData();
    },
    methods: {
        loadDataAccettazione(jsonData) {
            let me = this;
            me.filtro.idAccettazione = jsonData.id;
            me.filtro.forPage = me.perPage;
            me.filtro.page = me.currentPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataAccettazioneSuccess, me.loadDataAccettazioneError);
        },
        loadDataAccettazioneSuccess(response) {
            this.items = response.data.data.list;
        },
        loadDataAccettazioneError() {
            console.error("Errore nel caricamento dei dati per storico stati setting");
        },
    },
};
</script>
